import { Form, useParams } from "react-router-dom";
import {
    Container,
    Input,
} from "reactstrap";
import BreadCrumb from "../../../../../Components/Common/BreadCrumb";
import '../addProductMobile.scss';
import { useNavigate } from "react-router-dom";

const Attributes = (props: any) => {
    document.title = "Add Product | BuyPass";
    const { id, } = useParams();

    const navigate = useNavigate();

    return (
        <div className="page-content">
            <Container fluid>
                <BreadCrumb title={id ? "Edit Product" : "Add Product"} pageTitle="Products" pageTitleRoute="/manage-products" />
                <div className="addProductMianDv">
                    <form className="attributesForm">
                        <div className="formContainer">
                            <label className="form-label" htmlFor="password-input">
                                <span className="text-danger me-1">*</span>Model
                            </label>
                            <div className="position-relative auth-pass-inputgroup">
                                <Input
                                    className="form-control"
                                    placeholder="Please Input or Select Option"
                                    data-testing-Id="passwordInput_login"
                                    type="text"
                                />
                            </div>
                        </div>
                        <div className="formContainer">
                            <label className="form-label" htmlFor="password-input">
                                <span className="text-danger me-1">*</span>Campaign
                            </label>
                            <div className="position-relative auth-pass-inputgroup">
                                <Input
                                    className="form-control"
                                    placeholder="Input Here"
                                    data-testing-Id="passwordInput_login"
                                    type="text"
                                />
                            </div>
                        </div>
                        <div className="formContainer">
                            <label className="form-label" htmlFor="password-input">
                                <span className="text-danger me-1">*</span>Color Code Brand
                            </label>
                            <div className="position-relative auth-pass-inputgroup">
                                <Input
                                    className="form-control"
                                    placeholder="Input Here"
                                    data-testing-Id="passwordInput_login"
                                    type="text"
                                />
                            </div>
                        </div>
                        <div className="formContainer">
                            <label className="form-label" htmlFor="password-input">
                                <span className="text-danger me-1">*</span>Color Name Brand
                            </label>
                            <div className="position-relative auth-pass-inputgroup">
                                <Input
                                    className="form-control"
                                    placeholder="Input Here"
                                    data-testing-Id="passwordInput_login"
                                    type="text"
                                />
                            </div>
                        </div>
                        <div className="formContainer">
                            <label className="form-label" htmlFor="password-input">
                                <span className="text-danger me-1">*</span>Complementary Products
                            </label>
                            <div className="position-relative auth-pass-inputgroup">
                                <Input
                                    className="form-control"
                                    placeholder="Input Here"
                                    data-testing-Id="passwordInput_login"
                                    type="text"
                                />
                            </div>
                        </div>
                        <div className="formContainer">
                            <label className="form-label" htmlFor="password-input">
                                <span className="text-danger me-1">*</span>Main Material
                            </label>
                            <div className="position-relative auth-pass-inputgroup">
                                <Input
                                    className="form-control"
                                    placeholder="Input Here"
                                    data-testing-Id="passwordInput_login"
                                    type="text"
                                />
                            </div>
                        </div>
                        <div className="formContainer">
                            <label className="form-label" htmlFor="password-input">
                                <span className="text-danger me-1">*</span>Material Family
                            </label>
                            <div className="position-relative auth-pass-inputgroup">
                                <Input
                                    className="form-control"
                                    placeholder="Input Here"
                                    data-testing-Id="passwordInput_login"
                                    type="text"
                                />
                            </div>
                        </div>
                        <div className="formContainer">
                            <label className="form-label" htmlFor="password-input">
                                <span className="text-danger me-1">*</span>Season
                            </label>
                            <div className="position-relative auth-pass-inputgroup">
                                <select className="form-select" aria-label="Default select example">
                                    <option selected>select</option>
                                    <option value="1">One</option>
                                    <option value="2">Two</option>
                                    <option value="3">Three</option>
                                </select>

                            </div>
                        </div>
                        <div className="formContainer">
                            <label className="form-label" htmlFor="password-input">
                                <span className="text-danger me-1">*</span>Express_delivery
                            </label>
                            <div className="position-relative auth-pass-inputgroup">
                                <select className="form-select" aria-label="Default select example">
                                    <option selected>select</option>
                                    <option value="1">One</option>
                                    <option value="2">Two</option>
                                    <option value="3">Three</option>
                                </select>

                            </div>
                        </div>
                        <div className="formContainer">
                            <label className="form-label" htmlFor="password-input">
                                <span className="text-danger me-1">*</span>Clothing Material
                            </label>
                            <div className="position-relative auth-pass-inputgroup">
                                <select className="form-select" aria-label="Default select example">
                                    <option selected>select</option>
                                    <option value="1">One</option>
                                    <option value="2">Two</option>
                                    <option value="3">Three</option>
                                </select>

                            </div>
                        </div>
                        
                    </form>
                </div>
            </Container>
        </div>
    );
};

export default Attributes;